import { useEffect, useState } from 'react';
import './ApplicationReminders.css';
import { patentReminderFields, trademarkReminderFields } from '../../utilities/services/reminderFields';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { createApplicationReminder, getApplicationReminders } from '../../utilities/api/applicationReminders';
import { formNotificationStyle2 } from '../../utilities/services/formNotification';


const defaultFormData = {
    applicationType: '',
    fieldOfInterest: '',
    message: '',
    numberOfDays: '0',
    beforeOrAfter: '',
};

export default function ApplicationReminders({user, toggleNotifications}) {
    const [formData, setFormData] = useState(defaultFormData);
    const [reminders, setReminders] = useState([]);
    const [creatingReminder, setCreatingReminder] = useState(false);


    const getReminders = async () => {
        try {
            const data = await getApplicationReminders()
            setReminders(data);
        } catch (error) {
            console.log('Error fetching reminders:', error);
        }
    }

    const handleChange = (evt) => {
        const newFormData = {
            ...formData,
            [evt.target.name]: evt.target.value,
        };
        if (evt.target.name === 'applicationType') {
            newFormData.fieldOfInterest = '';
        }
        setFormData(newFormData);
    }

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        setCreatingReminder(true);
        try {
            const updatedReminderList = await createApplicationReminder(formData, user._id);
            setReminders(updatedReminderList);
            setFormData(defaultFormData);
            document.getElementById('newReminderForm').reset();
            formNotificationStyle2('createReminderNotification', 'Reminder Created!', '#0A7637', '1');
            toggleNotifications('success', `Reminder Created ${formData.numberOfDays} ${formData.numberOfDays==='1'? 'day':'days'} before ${(patentReminderFields.find(field => field.value === formData.fieldOfInterest)).name || (trademarkReminderFields.find(field => field.value === formData.fieldOfInterest)).name} for ${capitalizeFirstLetter(formData.applicationType)} Applications!`, '#FFFFFF');
        } catch (error) {
            console.log('Error creating reminder:', error);
            toggleNotifications('error', 'Failed to Create Reminder!', '#FFFFFF');
        }
        setCreatingReminder(false);
    }

    useEffect(() => {
        getReminders();
        // eslint-disable-next-line
    }, []);

    
  return (
    <div className='ApplicationReminders modal fade' id={`remindersModal`}  data-bs-keyboard="true">
        <div className='modal-dialog'>
            <div className="modal-content">
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg width="25" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                                <rect x="1.47275" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 1.47275 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                                <rect x="8.57383" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 8.57383 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                                Application Reminders
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                            <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='mainContainer'>
                    <div className='currentReminders'>
                        <div className='patentReminders'>
                            <div className='sectionTitle'>Patent Reminders</div>
                            <div className='sectionContent'>
                            {reminders.map((reminder, index) => (
                                reminder.applicationType === 'patent' &&
                                <div key={index} className='reminderItem tooltipContainer'>
                                    <div>
                                        {reminder.numberOfDays} Day{reminder.numberOfDays !== 1 && 's'}
                                    </div>
                                    <div>
                                        {reminder.beforeOrAfter === 'before' ? 'Before' : 'After'}
                                    </div>
                                    <div>
                                        {(patentReminderFields.find(field => field.value === reminder.fieldOfInterest)).name}
                                    </div>
                                    <span className="tooltiptext">{reminder.message}</span>
                                </div>
                            ))}
                            </div>
                        </div>
                        <div className='trademarkReminders'>
                            <div className='sectionTitle'>Trademark Reminders</div>
                            <div className='sectionContent'>
                            {reminders.map((reminder, index) => (
                                reminder.applicationType === 'trademark' &&
                                <div key={index} className='reminderItem tooltipContainer'>
                                    <div>
                                        {reminder.numberOfDays} Day{reminder.numberOfDays !== 1 && 's'}
                                    </div>
                                    <div>
                                        {reminder.beforeOrAfter === 'before' ? 'Before' : 'After'}
                                    </div>
                                    <div>
                                        {(trademarkReminderFields.find(field => field.value === reminder.fieldOfInterest)).name}
                                    </div>
                                    <span className="tooltiptext">{reminder.message}</span>
                                </div>
                            ))}
                            </div>
                        </div>
                    </div>
                    <div className='newReminder'>
                        <div className='sectionTitle'>New Reminder</div>
                        <form id='newReminderForm' onSubmit={handleSubmit}>
                            <div className='formContent'>
                                <div className="">
                                    <label htmlFor="applicationType" className="form-label">Reminder For:</label>
                                    <select className='form-select' name="applicationType" id="applicationType" defaultValue={formData.applicationType} onChange={handleChange} required>
                                        <option value="">---Select Application Type---</option>
                                        <option value="patent">Patent Applications</option>
                                        <option value="trademark">Trademark Applications</option>
                                    </select>
                                </div>
                                <div className="">
                                    <label htmlFor="numberOfDays" className="form-label">Number of Days:</label>
                                    <input type="number" min={1} className="form-control" name="numberOfDays" id="numberOfDays" defaultValue={formData.numberOfDays} onChange={handleChange} required />
                                </div>
                                <div className=''>
                                    <label htmlFor="beforeOrAfter" className="form-label">Before / After:</label>
                                    <select className='form-select' name="beforeOrAfter" id="beforeOrAfter" defaultValue={formData.beforeOrAfter} onChange={handleChange} required>
                                        <option value="">---Select Option---</option>
                                        <option value="before">Before</option>
                                        <option value="after">After</option>
                                    </select>
                                </div>
                                <div className="">
                                    <label htmlFor="fieldOfInterest" className="form-label">Applicable Date:</label>
                                    <select className='form-select' name="fieldOfInterest" id="fieldOfInterest" defaultValue={formData.fieldOfInterest} onChange={handleChange} required>
                                        <option value="">---Select Date of Interest---</option>
                                        {formData.applicationType === 'patent' && 
                                        <>
                                        {patentReminderFields.map((field, index) => (
                                            <option key={index} value={field.value}>{field.name}</option>
                                        ))}
                                        </>
                                        }
                                        {formData.applicationType === 'trademark' && 
                                        <>
                                        {trademarkReminderFields.map((field, index) => (
                                            <option key={index} value={field.value}>{field.name}</option>
                                        ))}
                                        </>
                                        }
                                    </select>
                                </div>
                                <div className="">
                                    <label htmlFor="message" className="form-label">Message:</label>
                                    <textarea className="form-control" rows={2} name="message" id="message" defaultValue={formData.message} onChange={handleChange} required />
                                </div>
                            </div>
                            <div id='createReminderNotification' className='text-center'></div>
                            <div className='buttonContainer'>
                                <button type="submit" form='newReminderForm' className="submit" disabled={creatingReminder}>Create Reminder</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
